export default __webpack_public_path__ + "static/media/terrain.831491e2.png";